import Color from "color";
import hexRgb from "hex-rgb";

/**
 * User roles constants.
 */
export const ROLES = Object.freeze({
    SUPPLIER: "supplier",
    SUPPLIER_ACCESS: "supplier_access",
    DISPATCH: "dispatch"
});


/**
 * Change Primary Color
 * @param {string} primary - The primary color in hex format.
 * @param {string} buttonText - The button text color in hex format.
 * @param {string} elementId - The ID of the HTML element to apply the styles to. Default is "wrapper".
 */
export function changePrimaryColor(primary, buttonText, elementId = "wrapper") {
    let white = "#FFFFFF";
    let black = "#000000";
    let body = "#666";
    var color = Color(primary);
    let primaryColor = Color.rgb(color.rgb().array());
    let whiteColor = Color(white);
    let bodyColor = Color(body);

    let element = document.getElementById(elementId);

    document.body.style.setProperty("--primary-tooltip", primaryColor);
    document.body.style.setProperty("--primary", primaryColor.hex());
    document.body.style.setProperty("--color-button", primaryColor.hex());
    document.body.style.setProperty("--button-inverse", primaryColor.hex());
    document.body.style.setProperty("--buttonText", buttonText);
    if (element) {
        element.style.setProperty("--primary", primaryColor.hex());
        element.style.setProperty("--buttonText", buttonText);
        element.style.setProperty("--color-button", primaryColor.hex());
        element.style.setProperty("--button-inverse", primaryColor.hex());
        element.style.setProperty("--primary", primaryColor.hex());
        element.style.setProperty("--color-button", primaryColor.hex());
        element.style.setProperty("--button-inverse", primaryColor.hex());
        element.style.setProperty(
            "--primary-darken-10",
            primaryColor.darken(0.1)
        );
        element.style.setProperty(
            "--primary-darken-15",
            primaryColor.darken(0.15)
        );
        element.style.setProperty(
            "--primary-darken-20",
            primaryColor.darken(0.2)
        );
        element.style.setProperty(
            "--primary-lighten-25",
            primaryColor.lighten(0.25)
        );
        element.style.setProperty(
            "--primary-lighten-90",
            primaryColor.lighten(0.9)
        );
        element.style.setProperty(
            "--primary-rgb-4",
            hexRgb(primaryColor.hex(), {
                alpha: 0.04,
                format: "css"
            })
        );
        element.style.setProperty(
            "--primary-rgb-6",
            hexRgb(primaryColor.hex(), {
                alpha: 0.06,
                format: "css"
            })
        );
        element.style.setProperty(
            "--primary-rgb-20",
            hexRgb(primaryColor.hex(), {
                alpha: 0.2,
                format: "css"
            })
        );
        element.style.setProperty(
            "--primary-rgb-40",
            hexRgb(primaryColor.hex(), {
                alpha: 0.4,
                format: "css"
            })
        );
        element.style.setProperty(
            "--primary-rgb-45",
            hexRgb(primaryColor.hex(), {
                alpha: 0.45,
                format: "css"
            })
        );
        element.style.setProperty(
            "--primary-rgb-60",
            hexRgb(primaryColor.hex(), {
                alpha: 0.6,
                format: "css"
            })
        );
        element.style.setProperty(
            "--primary-rgb-70",
            hexRgb(primaryColor.hex(), {
                alpha: 0.7,
                format: "css"
            })
        );

        element.style.setProperty(
            "--primary-rgb-80",
            hexRgb(primaryColor.hex(), {
                alpha: 0.8,
                format: "css"
            })
        );
        element.style.setProperty(
            "--primary-rgb-100",
            hexRgb(primaryColor.hex(), {
                alpha: 1,
                format: "css"
            })
        );
        element.style.setProperty("--primary-color-yiq", "");
        element.style.setProperty("--white", whiteColor.hex());
        element.style.setProperty(
            "--white-rgb-30",
            hexRgb(whiteColor.hex(), { alpha: 0.3, format: "css" })
        );
        element.style.setProperty(
            "--white-rgb-50",
            hexRgb(whiteColor.hex(), { alpha: 0.5, format: "css" })
        );
        element.style.setProperty(
            "--white-rgb-60",
            hexRgb(whiteColor.hex(), { alpha: 0.6, format: "css" })
        );
        element.style.setProperty(
            "--white-rgb-100",
            hexRgb(whiteColor.hex(), { alpha: 1, format: "css" })
        );

        element.style.setProperty(
            "--black-rgb-10",
            hexRgb(black, { alpha: 0.1, format: "css" })
        );
        element.style.setProperty(
            "--black-rgb-30",
            hexRgb(black, { alpha: 0.3, format: "css" })
        );
        element.style.setProperty(
            "--black-rgb-100",
            hexRgb(black, { alpha: 1, format: "css" })
        );
        element.style.setProperty("--body-color", bodyColor.hex());
        element.style.setProperty(
            "--body-color-lighten-10",
            bodyColor.lighten(0.1)
        );
        element.style.setProperty(
            "--button-inverse-rgb-6",
            hexRgb(primaryColor.hex(), {
                alpha: 0.06,
                format: "css"
            })
        );
        element.style.setProperty(
            "--button-inverse-lighten-50",
            hexRgb(primaryColor.hex(), {
                alpha: 0.05,
                format: "css"
            })
        );
    }
}

/** Unauthorized Action
 * @param {object} error - The error object from an HTTP request.
 * @returns {boolean} - Returns true if the error code is 401 (Unauthorized), otherwise false.
 */
export function unauthorizedAction(error) {
    if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
            return true;
        } else {
            return false;
        }
    } else if (error.request) {
        return false;
    } else {
        return false;
    }
}

/** Navigate Back
 * @param {object} self - The Vue component instance (usually 'this').
 */
export function goBack(self) {
    if (window.history.length > 1) {
        self.$router.go(-1);
    } else {
        self.$router.push('/');
    }
}

/** Get Reservation Module Type
 * @param {string} productCode - The product code.
 * @param {string} productId - The product ID.
 * @returns {string} - Returns the reservation module type based on the provided parameters.
 */
export function getReservationModuleType(productCode, productId) {
    if (productCode) {
        return "INTERNAL_PRODUCT"
    } else if (productId) {
        return "VENTRATA_PRODUCT"
    } else {
        return "TRANSFERS"
    }
}

/**
 * Simple throttle function that executes a passed function only once in the specified timeout
 * @param handlerFunc
 * @param [timeout] the throttle interval
 */
export function throttle(handlerFunc, timeout = 66) {
    let resizeTimeout;
    if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
            resizeTimeout = null;
            handlerFunc();
            // The actualResizeHandler will execute at a rate of 15fps
        }, timeout);
    }
}

/** * Validate email format.
 * @param {string} email - The email string.
 * @returns {boolean} - True if email is valid, false otherwise.
 */
export function validateEmail(email) {
    return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
}

/** * Get ID parameter pattern for routes.
 * @param {string} paramName - The name of the parameter. Default is "id".
 * @returns {string} - The route parameter pattern for a 24-character hexadecimal ID.
 */
export function idParam(paramName = "id") {
    return `:${paramName}([a-fA-F0-9]{24})`;
}